export default __webpack_public_path__ + "static/media/yellowwarning.fa0f0cd3.svg";